module.exports = __webpack_public_path__ + "img/C007 F A4 - Lkes 【SSRB】.bb141b45.png";